<template>
	 <div>
	 <div class="wrap" v-if="isMobile">
		  <div v-if="isShow">
			<div class="mExamResult">
					<h2>游戏代练师技能认定线上考试</h2>
					<div class="exam-search-result" v-if="hasData">
						<div class="item">
							<div class="label-item">考试名称：</div>
							<div class="input-item">
								{{title}}
							</div>
						</div>

						<div class="item">
							<div class="label-item">考生姓名：</div>
							<div class="input-item">
								{{name}}
							</div>
						</div>
						<div class="item">
							<div class="label-item">证件号码：</div>
							<div class="input-item">
								{{idcardNo}}
							</div>
						</div>

						<div class="item">
							<div class="label-item">考试时间：</div>
							<div class="input-item">
								{{formatDate(startDate)}}至{{formatDate(endDate)}}
							</div>
						</div>

						<div class="item">
							<div class="label-item">剩余次数：</div>
							<div class="input-item">
								{{restCount}}次
							</div>
						</div>

						<div class="item">
							<div class="label-item">考试耗时：</div>
							<div class="input-item">
								{{diffMinute}}分钟
							</div>
						</div>

						<div class="item">
							<div class="label-item">考试得分：</div>
							<div class="input-item">
								{{grade}}分
							</div>
						</div>

						<div class="item">
							<div class="label-item">考试成绩：</div>
							<div class="input-item">
								{{comment}}
							</div>
						</div>
					</div>
					<div class="exam-search-result" v-else>
						<!-- <div class="item"><img class="vam" src="../assets/baoming.png" width="180"><span>暂无笔试成绩</span></div> -->
						
						<div class="item">
							<div class="label-item">考试名称：</div>
							<div class="input-item">
								{{level}}游戏代练师-{{game}}技能认定笔试
							</div>
						</div>

						<div class="item">
							<div class="label-item">考生姓名：</div>
							<div class="input-item">
								{{name}}
							</div>
						</div>
						<div class="item">
							<div class="label-item">证件号码：</div>
							<div class="input-item">
								{{idcardNo}}
							</div>
						</div>

						<div class="item">
							<div class="label-item">剩余次数：</div>
							<div class="input-item">
								{{restCount}}次
							</div>
						</div>

						<div class="item">
							<div class="label-item">考试题目：</div>
							<div class="input-item">
								{{getquestionsCount}}道
							</div>
						</div>

						<div class="item">
							<div class="label-item">考试时长：</div>
							<div class="input-item">
								{{countdown}}分钟
							</div>
						</div>

						<div class="item">
							<div class="label-item">及格分数：</div>
							<div class="input-item">
								{{passingScore}}分
							</div>
						</div>


					</div>

					<div class="exam-search-result" >
						<div class="item" v-if="status==11">
							<el-button type="primary" @click="goAnswerQuestions()" size="small">去答题</el-button>
						</div>
						<div class="item" v-else>
							<router-link  to="/home" ><el-button size="small">返 回</el-button></router-link>
						</div>
					</div>
			</div>
			</div>
	 </div>
	 <div v-else>
     <div class="content" v-if="isShow">
	 <div class="examResult">
			<h2>游戏代练师技能认定线上考试</h2>
			<div class="exam-search-result" v-if="hasData">
				<div class="item">
					<div class="label-item">考试名称：</div>
					<div class="input-item">
						{{title}}
					</div>
				</div>

				<div class="item">
					<div class="label-item">考生姓名：</div>
					<div class="input-item">
						{{name}}
					</div>
				</div>
				<div class="item">
					<div class="label-item">证件号码：</div>
					<div class="input-item">
						{{idcardNo}}
					</div>
				</div>

				<div class="item">
					<div class="label-item">考试时间：</div>
					<div class="input-item">
						{{formatDate(startDate)}}至{{formatDate(endDate)}}
					</div>
				</div>

				<div class="item">
					<div class="label-item">剩余次数：</div>
					<div class="input-item">
						{{restCount}}次
					</div>
				</div>

				<div class="item">
					<div class="label-item">考试耗时：</div>
					<div class="input-item">
						{{diffMinute}}分钟
					</div>
				</div>

				<div class="item">
					<div class="label-item">考试得分：</div>
					<div class="input-item">
						{{grade}}分
					</div>
				</div>

				<div class="item">
					<div class="label-item">考试成绩：</div>
					<div class="input-item">
						{{comment}}
					</div>
				</div>
			</div>
			<div class="exam-search-result" v-else>
				<!-- <div class="item"><img class="vam" src="../assets/baoming.png" width="180"><span>暂无笔试成绩</span></div> -->
				
				<div class="item">
					<div class="label-item">考试名称：</div>
					<div class="input-item">
						{{level}}游戏代练师-{{game}}技能认定笔试
					</div>
				</div>

				<div class="item">
					<div class="label-item">考生姓名：</div>
					<div class="input-item">
						{{name}}
					</div>
				</div>
				<div class="item">
					<div class="label-item">证件号码：</div>
					<div class="input-item">
						{{idcardNo}}
					</div>
				</div>

				<div class="item">
					<div class="label-item">剩余次数：</div>
					<div class="input-item">
						{{restCount}}次
					</div>
				</div>

				<div class="item">
					<div class="label-item">考试题目：</div>
					<div class="input-item">
						{{getquestionsCount}}道
					</div>
				</div>

				<div class="item">
					<div class="label-item">考试时长：</div>
					<div class="input-item">
						{{countdown}}分钟
					</div>
				</div>

				<div class="item">
					<div class="label-item">及格分数：</div>
					<div class="input-item">
						{{passingScore}}分
					</div>
				</div>


			</div>

			<div class="exam-search-result" >
				<div class="item" v-if="status==11">
					<el-button type="primary" @click="goAnswerQuestions()" size="small">去答题</el-button>
				</div>
				<div class="item" v-else>
					<router-link  to="/home" ><el-button size="small">返 回</el-button></router-link>
				</div>
			</div>
	 </div>
     </div>
	 </div>
	 </div>
</template>
<style scoped>
.examResult{background:#fff; overflow:hidden; margin:16px 0; font-size:14px; padding-bottom: 50px; }
.examResult h2{ height:84px; line-height:84px; font-size:24px; border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal; margin-bottom: 50px; text-align: center;}
.examResult .exam-search-result{background:#fff; overflow:hidden; margin:16px 0; font-size:14px; padding-bottom:40px; }
.examResult .exam-search-result h2{ height:84px; line-height:84px; font-size:24px; border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal; margin-bottom: 50px; text-align: center;}
.examResult .exam-search-result .item{text-align: center; padding-bottom:24px; color:#8c8c8c; line-height: 28px;}
.examResult .exam-search-result .label-item{ width:40%;display: inline-block; text-align: right; }
.examResult .exam-search-result .input-item{width:58%; display: inline-block; text-align: left; font-size:16px;color:#111; }
.examResult .exam-search-result input{height:20px;}
.examResult .exam-search-result .msg{font-size:14px; color:#f5222d; line-height:24px; position: absolute;}
.examResult .exam-search-result .msg1{font-size:14px; color:#f5222d; line-height:24px; position: absolute; padding-left:135px;}
.examResult .exam-search-result span{display: block; font-size: 16px; margin-top: 24px;}


.mExamResult{background:#fff; overflow:hidden; margin:0.8rem 0; font-size:1rem; padding-bottom: 2.5rem; }
.mExamResult h2{ height:5rem; line-height:5rem; font-size:1.4rem;  border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal;  text-align: center; }
.mExamResult .exam-search-result{background:#fff; overflow:hidden; margin:2rem 0; font-size:1.2rem; }
.mExamResult .exam-search-result h2{ height:5rem; line-height:5rem; font-size:1.2rem; border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal; margin-bottom:2.5rem; text-align: center;}
.mExamResult .exam-search-result .item{text-align: center; padding:0.8rem 0; color:#8c8c8c; }
.mExamResult .exam-search-result .label-item{ width:25%;display: inline-block; text-align: right; }
.mExamResult .exam-search-result .input-item{width:73%; display: inline-block; text-align: left; font-size:1.2rem;color:#111; }
.mExamResult .exam-search-result input{height:1rem;}
.mExamResult .exam-search-result .msg{font-size:1.2rem; color:#f5222d; line-height:1.2rem; position: absolute;}
.mExamResult .exam-search-result .msg1{font-size:1.2rem; color:#f5222d; line-height:1.2rem; position: absolute; }
.mExamResult .exam-search-result span{display: block; font-size: 0.8rem; margin-top:1.2rem;}
</style>
<script>   
	export default {
		name: 'examResult',
		methods: {
			formatDate(date){
				var crtTime = new Date(date);
				return this.http.dateFormat("yyyy-MM-dd hh:mm",crtTime);
			},
			getResult(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.isShow=false;
				self.http.ajaxGet("ExamResult?UserID="+userId,function(res){
				if(res.ReturnCode == 1){
					self.hasData=res.Result[0].HasData==1?true:false;
					self.name=res.Result[0].Name;
					self.idcardNo=res.Result[0].IDCard;
					self.grade=res.Result[0].Grade;
					self.comment=res.Result[0].Comment;
					self.diffMinute=res.Result[0].DiffMinute==0?1:res.Result[0].DiffMinute;
					self.title=res.Result[0].Title;
					self.startDate=res.Result[0].StartDate;
					self.endDate=res.Result[0].EndDate;
					self.status=res.Result[0].Status;
					self.isShow=true;
					self.restCount=res.Result[0].WrittenTestCount;

					self.countdown=res.Result[0].Countdown;
					self.questionsCount=res.Result[0].QuestionsCount;
					self.passingScore=res.Result[0].PassingScore;

					self.game=res.Result[0].Game;
					self.level=res.Result[0].Level;
				}else{
					if(res.ReturnCode==-1){
						if(self.isMobile){
							self.$alert(res.Message, '', {
							confirmButtonText: '去实名',
							customClass:'mfuli-message-box',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/auth'});
							}
							});
						}else{
							self.$alert(res.Message, '', {
							confirmButtonText: '去实名',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/auth'});
							}
							});
						}
					}
					else if(res.ReturnCode==-2){
						if(self.isMobile){
							self.$alert(res.Message, '', {
							confirmButtonText: '去报名',
							customClass:'mfuli-message-box',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/sign-up'});
							}
							});
						}else{
							self.$alert(res.Message, '', {
							confirmButtonText: '去报名',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/sign-up'});
							}
							});
						}
					}
					else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}
				}	
				},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			goAnswerQuestions(){
				//检查是否可以去答题
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("CheckQuestions?UserID="+userId,function(res){
				if(res.ReturnCode == 1){
					var valid=res.Result[0].Valid;
					
					if(valid==0){
						if(self.isMobile){
							var msg="理论考试总共"+self.getquestionsCount+"道题，总时长"+self.countdown+"分钟，"+self.passingScore+"分及格，您确定要去答题吗？";
							self.$confirm(msg, '提示', {
							confirmButtonText: '去答题',
							customClass:'mfuli-message-box',
							cancelButtonText: '取消',
							type: 'warning'
							}).then(() => {self.$router.push({path:'/examination'});})
						}else{
							var msg="理论考试总共"+self.getquestionsCount+"道题，总时长"+self.countdown+"分钟，"+self.passingScore+"分及格，您确定要去答题吗？";
							self.$confirm(msg, '提示', {
							confirmButtonText: '去答题',
							cancelButtonText: '取消',
							type: 'warning'
							}).then(() => {self.$router.push({path:'/examination'});})
						}
					}else if(valid==1){
						if(self.isMobile){
							var msg="您当前正在进行理论考试，是否继续答题？";
							self.$confirm(msg, '提示', {
							confirmButtonText: '去答题',
							customClass:'mfuli-message-box',
							cancelButtonText: '取消',
							type: 'warning'
							}).then(() => {self.$router.push({path:'/examination'});})
						}else{
							var msg="您当前正在进行理论考试，是否继续答题？";
							self.$confirm(msg, '提示', {
							confirmButtonText: '去答题',
							cancelButtonText: '取消',
							type: 'warning'
							}).then(() => {self.$router.push({path:'/examination'});})
						}
					}else {
						if(self.isMobile){
							self.$alert('本次答题已经结束', '', {
							confirmButtonText: '确定',
							customClass:'mfuli-message-box',
							type:"info",
							showClose:false,
							callback: action => {
								self.getResult();
							}
							});
						}else{
							self.$alert('本次答题已经结束', '', {
							confirmButtonText: '确定',
							type:"info",
							showClose:false,
							callback: action => {
								self.getResult();
							}
							});
						}
					}
				}else{
					if(self.isMobile){
						self.$alert(res.Message, '', {
						confirmButtonText: '确定',
						customClass:'mfuli-message-box',
						type:"info",
						showClose:false,
						callback: action => {
							if(res.ReturnCode==-2){
								self.$router.push({path:'/sign-up'});
							}
							else if(res.ReturnCode==-5){
								self.$router.push({path:'/exam-result'});
							}
							else{
								self.$router.push({path:'/home'});
							}
						}
						});
					}else{
						self.$alert(res.Message, '', {
						confirmButtonText: '确定',
						type:"info",
						showClose:false,
						callback: action => {
							if(res.ReturnCode==-2){
								self.$router.push({path:'/sign-up'});
							}
							else if(res.ReturnCode==-5){
								self.$router.push({path:'/exam-result'});
							}
							else{
								self.$router.push({path:'/home'});
							}
						}
						});
					}
				}	
				},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})

				
			}
		},
		data() {
			return {
				idcard:"",
				isSubmit:false,
				isShowCode:true,
				result1:false,
				result2:false,
				hasData:true,
				title:'游戏代练师-初级王者荣耀技能认定笔试',
				idcardNo:'',
				name:'',
				date:'',
				grade:'',
				comment:'',
				diffMinute:10,
				startDate:'',
				endDate:'',
				status:1,
				isShow:false,
				restCount:0,
				countdown:0,
				questionsCount:'',
				passingScore:0,
				game:'',
				level:''
			}
		},
		computed:{
			getquestionsCount(){
				var arr=this.questionsCount.split("|");
				var count=0;
				for(var i=0;i<arr.length;i++){
					count=count+parseInt(arr[i]);
				}
				return count;
			},
			isMobile(){
				return this.common.isMobile();
			}
		},
		mounted: function () {
			this.getResult();
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/exam-result.vue